import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { normalize } from '../../../helpers/pagination';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";

const state = {
  refresh: {
    isBusy: false,
    data: null,
    error: null
  },
  settings: {
    isBusy: false,
    data: [],
    error: null
  },
  status: {
    isBusy: false,
    data: {},
    error: null
  }
};

const mutations = {
  REFRESH_MASTER_VIEW_BUSY: (state, payload) => {
    state.refresh.isBusy = payload;
  },
  REFRESH_MASTER_VIEW_SUCCESS: (state, payload) => {
    state.refresh.isBusy = false;
    state.refresh.data = payload;
    state.refresh.error = null;
  },
  REFRESH_MASTER_VIEW_FAIL: (state, payload) => {
    state.refresh.isBusy = false;
    state.refresh.error = payload;
  },

  GET_MASTER_VIEW_SETTINGS_BUSY: (state, payload) => {
    state.settings.isBusy = payload;
  },
  GET_MASTER_VIEW_SETTINGS_SUCCESS: (state, payload) => {
    state.settings.isBusy = false;
    state.settings.data = payload;
    state.settings.error = null;
  },
  GET_MASTER_VIEW_SETTINGS_FAIL: (state, payload) => {
    state.settings.isBusy = false;
    state.settings.error = payload;
  },

  SAVE_MASTER_VIEW_SETTINGS_BUSY: (state, payload) => {
    state.settings.isBusy = payload;
  },
  SAVE_MASTER_VIEW_SETTINGS_SUCCESS: (state, payload) => {
    state.settings.isBusy = false;
    state.settings.data = payload;
    state.settings.error = null;
  },
  SAVE_MASTER_VIEW_SETTINGS_FAIL: (state, payload) => {
    state.settings.isBusy = false;
    state.settings.error = payload;
  },

  GET_MASTER_VIEW_STATUS_BUSY: (state, payload) => {
    state.status.isBusy = payload;
  },
  GET_MASTER_VIEW_STATUS_SUCCESS: (state, payload) => {
    state.status.isBusy = false;
    state.status.data = payload;
    state.status.error = null;
  },
  GET_MASTER_VIEW_STATUS_FAIL: (state, payload) => {
    state.status.isBusy = false;
    state.status.error = payload;
  },
};

const actions = {
  refresh: ({ commit, rootState }, { projectId, forceRefresh }) => {
    commit('REFRESH_MASTER_VIEW_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    const body = {
      forceRefresh: forceRefresh === true
    };

    return Axios
      .post(`${API_HOST}/projects/${projectId}/queries/refresh`, body, config)
      .then((response) => {
        let data = response.data;
        if (data.status.message === "OK") {
          Vue.notify({
            group: 'store_notifications',
            type: 'success',
            text: i18n.t('messages.queries.refresh_success')
          });
          commit('REFRESH_MASTER_VIEW_SUCCESS', data)
        }
        else {
          throw new Error(data.status.message)
        }
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('REFRESH_MASTER_VIEW_FAIL', error);
      })
  },

  getSettings: ({ commit, rootState }, { projectId }) => {
    commit('GET_MASTER_VIEW_SETTINGS_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    Axios
      .get(`${API_HOST}/projects/${projectId}/queries/mv_settings`, config)
      .then(({ data: { data = [], status} }) => {
        if (status.message === "OK") commit('GET_MASTER_VIEW_SETTINGS_SUCCESS', data)
        else throw new Error(status.message)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('GET_MASTER_VIEW_SETTINGS_FAIL', error)
      })
  },

  saveSettings: ({ commit, rootState }, { projectId, data }) => {
    commit('SAVE_MASTER_VIEW_SETTINGS_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    Axios
      .post(`${API_HOST}/projects/${projectId}/queries/mv_settings`, data, config)
      .then(({ data: { data, status }}) => {
        if (status.message === "OK") {
          commit('SAVE_MASTER_VIEW_SETTINGS_SUCCESS', data)
          Vue.notify({
            group: 'store_notifications',
            type: 'success',
            text: i18n.t('messages.queries.save_settings_success')
          });
        }
        else throw new Error(status.message)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('SAVE_MASTER_VIEW_SETTINGS_FAIL', error)
      })
  },

  getMasterViewStatus: ({ commit, rootState }, { projectId }) => {
    commit('GET_MASTER_VIEW_STATUS_BUSY', true);

    const config = { headers: { Authorization: setAccessToken(rootState) } };
    return Axios
      .get(`${API_HOST}/projects/${projectId}/queries/mv_status`, config)
      .then(r => {
        commit('GET_MASTER_VIEW_STATUS_SUCCESS', r.data.data);
        return r.data.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
        commit('GET_MASTER_VIEW_STATUS_FAIL', error);
        console.error(error);
      });
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};